import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Button,
    Col,
    Row
} from 'reactstrap';
import {Field, reduxForm} from 'redux-form';
import {InputField} from "../../../validation/ReduxFormInput";
import {normalizePhone} from "../../../util/normalizers";
import {setUser} from "../../../store/actions/user";

class OwnerBasic extends Component {
    render() {

        const {handleSubmit, setUser} = this.props;

        return (
            <div>
                <h3>Let's find you some tenants!</h3>
                <hr/>
                <form onSubmit={handleSubmit(setUser)}>
                    <Row>
                        <Col><Field name="first_name" label="First Name" component={InputField}/></Col>
                        <Col><Field name="last_name" label="Last Name" component={InputField}/></Col>
                    </Row>
                    <Row>
                        <Col><Field name="phone" label="Phone" component={InputField} normalize={normalizePhone}/></Col>
                        <Col><Field name="email" label="Email" component={InputField} type="email"/></Col>
                    </Row>
                    <Button type="submit" color="success" block outline id="owner-basic">Continue</Button>
                </form>
            </div>
        );
    }
}

const validate = (values) => {
    const errors = {};

    !values.first_name && (errors.first_name = 'Required');
    !values.last_name && (errors.last_name = 'Required');
    !values.phone && (errors.phone = 'Required');
    !values.email && (errors.email = 'Required');

    return errors;
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch, props) => ({
    setUser(data) {
        data.user_type = 'landlord';
        dispatch(setUser(data));
        props.onContinue();
    }
});

OwnerBasic = reduxForm({
    form: 'owner_basic',
    validate
})(OwnerBasic);

export default connect(mapStateToProps, mapDispatchToProps)(OwnerBasic);


// WEBPACK FOOTER //
// ./src/containers/authentication/OwnerRegisterFlow/OwnerBasic.js